import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9cb7dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { slot: "fixed" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "info-area" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ion_button, {
        id: "back-button",
        slot: "start",
        fill: "clear",
        onClick: $options.closeModal
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_icon, {
            icon: $setup.arrowBack,
            color: "light"
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, [
          _createTextVNode("#" + _toDisplayString($props.order.id), 1),
          _hoisted_4,
          _createTextVNode(_toDisplayString($props.order.establishment.name), 1)
        ])
      ]),
      _createVNode(_component_ion_buttons, {
        slot: "end",
        fill: "clear",
        shape: "round",
        color: "light"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, { href: $setup.phone }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: $setup.call }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["href"])
        ]),
        _: 1
      })
    ]),
    _hoisted_5
  ]))
}